export default __webpack_public_path__ + "static/media/Glitch Garden.f9d59fdd.png";